import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const CulturalContentsIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 52 52"
    sx={{ width: '52px', height: '52px', ...sx }}
    {...props}
  >
    <mask
      id="a"
      width="44"
      height="44"
      x="4"
      y="4"
      maskUnits="userSpaceOnUse"
      style={{ maskType: 'alpha' }}
    >
      <path
        fill="#6264A7"
        d="M12.035 41.235a1.27 1.27 0 1 0 0-2.54 1.27 1.27 0 0 0 0 2.54Z"
      />
      <path
        fill="#6264A7"
        d="M5.603 47.666H24.73V27.27H4.333v19.127a1.269 1.269 0 0 0 1.27 1.27Zm6.432-11.513c.433.004.863.083 1.27.234v-4.042a1.27 1.27 0 0 1 1.841-1.135l5.079 2.539a1.272 1.272 0 0 1-1.137 2.275l-3.24-1.625v5.563a3.81 3.81 0 1 1-3.813-3.81ZM13.305 17.284l4.059-2.709-4.06-2.705v5.414Z"
      />
      <path
        fill="#6264A7"
        d="M24.73 4.333H5.603a1.269 1.269 0 0 0-1.27 1.27V24.73H24.73V4.333ZM20.357 15.63l-7.618 5.079a1.27 1.27 0 0 1-1.974-1.056V9.497A1.27 1.27 0 0 1 12.74 8.44l7.617 5.079a1.27 1.27 0 0 1 0 2.112ZM27.27 38.17l4.265-4.18a1.27 1.27 0 0 1 1.795 0l1.641 1.64 4.18-4.18a1.267 1.267 0 0 1 1.796 0l6.716 6.717V27.269H27.27V38.17Z"
      />
      <path
        fill="#6264A7"
        d="m36.766 37.424 1.641 1.642a1.27 1.27 0 1 1-1.795 1.795l-4.18-4.18-5.163 5.078v5.906h19.128a1.269 1.269 0 0 0 1.27-1.27V41.76l-7.617-7.617-3.284 3.282ZM32.811 13.305h2.54v2.539h-2.54v-2.54ZM37.89 16.331l2.539 1.27v-6.048l-2.54 1.27v3.508Z"
      />
      <path
        fill="#6264A7"
        d="M46.406 4.333H27.278V24.73h20.397V5.603a1.268 1.268 0 0 0-1.27-1.27Zm-2.54 15.32a1.269 1.269 0 0 1-1.841 1.135l-4.81-2.405h-4.778a1.269 1.269 0 0 1-1.27-1.27v-5.078a1.266 1.266 0 0 1 1.27-1.27h4.778l4.81-2.405a1.27 1.27 0 0 1 1.841 1.135v10.158Z"
      />
    </mask>
    <g mask="url(#a)">
      <path fill="#fff" d="M4.333 4.333h43.333v43.333H4.333z" />
    </g>
  </SvgIcon>
)

CulturalContentsIcon.defaultProps = {
  sx: null,
}
